export default __webpack_public_path__ + "static/media/umair.7c8c3450.jpg";